import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CloseIcon from '@mui/icons-material/Close';
import { Button, ClickAwayListener, Grow, IconButton, MenuItem, MenuList, Paper, Popper, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { archLevel } from 'src/data/config';
import { useAppSelector } from 'src/store/hooks';
import './DashboardNavbar.scss';
import { useLocation } from 'react-router-dom';

export enum MenuType {
  Sponsor,
  Study,
  Country,
  Site,
  resData
}

export interface resData {
  name: string;
  role: string;
}
export interface IMenuProps {
  menuType: MenuType;
  label: string;
  value: string;
  options: string[];
  resData: resData[];
  onChange?: (item: string, menuType: MenuType, resData: resData[]) => void;
}

const MenuItemComponent: React.FC<IMenuProps> = ({ menuType, label, value, options, resData, onChange }) => {
  const location = useLocation();
  const { tab: tabVal, tabsData } = useAppSelector(state => state.tabs);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>();
  const [open, setOpen] = React.useState(false);
  const [showif, setShowif] = useState(false);

  const selectedSubject = useAppSelector(state => state.selectedSubjectInfo.selectedSubject);
  const openResupplyOrder = useAppSelector(state => state.drugSupplySlice.openResupplyOrderPage);
  const emrId = useAppSelector(state => state.selectedEMR.id);
  const toggle = (event: React.MouseEvent<HTMLElement>) => {
    setOpen(prevOpen => !prevOpen);
    setAnchorEl(event.currentTarget);
  };

  const handleChange = (item: string) => {
    onChange && onChange(item, menuType, resData);
  };

  const getIsLevelClearable = (data: any) => {
    if (menuType === MenuType.Sponsor) {
      return data.Sponsor;
    } else if (menuType === MenuType.Study) {
      return data.Study;
    } else if (menuType === MenuType.Country) {
      return data.Country;
    } else if (menuType === MenuType.Site) {
      return data.Site;
    } else {
      return false;
    }
  };
  useEffect(() => {
    if (tabVal > -1 && tabsData.length > 0) {
      const selectedTabObj: any = tabsData.filter((tab: any) => tab.index === tabVal);
      setShowif(getIsLevelClearable(selectedTabObj?.[0]?.tabHierarchyLevels));
    } else {
      setShowif(false);
    }
  }, [tabVal]);

  const filterUniqOptions = (menuTypePar: number, arr: string[]): string[] =>
    menuTypePar !== MenuType.Sponsor ? [...new Set(arr)] : arr;

  return (
    <Tooltip
      title={
        value && value.length > 20
          ? value
          : openResupplyOrder
          ? 'Study hierarchy is not allowed to change when resupply order form is open'
          : ``
      }
    >
      <span>
        <Button
          variant="contained"
          endIcon={<ArrowDropDownIcon />}
          aria-haspopup="menu"
          onClick={e => {
            toggle(e);
          }}
          disabled={Boolean(selectedSubject) || Boolean(emrId) || openResupplyOrder}
        >
          {label}: &nbsp; <span>{value}</span>
          {(showif || location.pathname === '/visit-schedule') && archLevel == 'sponsor' ? (
            <IconButton
              sx={{ display: value === '' ? 'none' : '' }}
              aria-label="delete"
              size="small"
              className={value === '' ? 'hide' : 'close-small-btn'}
              onClick={() => handleChange('')}
            >
              {' '}
              <CloseIcon />
            </IconButton>
          ) : null}
          <Popper open={open} anchorEl={anchorEl} transition disablePortal placement="bottom-start">
            {({ TransitionProps }) => (
              <Grow {...TransitionProps}>
                <Paper elevation={4}>
                  <ClickAwayListener onClickAway={() => setOpen(false)}>
                    <MenuList id="split-button-menu" autoFocusItem>
                      {filterUniqOptions(menuType, options).map((item, index) => (
                        <MenuItem key={index} value={item} onClick={() => handleChange(item)}>
                          {item}
                        </MenuItem>
                      ))}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </Button>
      </span>
    </Tooltip>
  );
};

export default MenuItemComponent;
